module.exports = __webpack_public_path__ + "static/media/miners.71108cd5.gif";